//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.2.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class Client {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "http://localhost:7071";

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRecipeCollectionRecipe(collectionId: string, recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/recipes/{recipeId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRecipeCollectionRecipe(_response);
        });
    }

    protected processAddRecipeCollectionRecipe(response: AxiosResponse): Promise<RecipeCollectionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    removeRecipeFromRecipeCollection(collectionId: string, recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/recipes/{recipeId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveRecipeFromRecipeCollection(_response);
        });
    }

    protected processRemoveRecipeFromRecipeCollection(response: AxiosResponse): Promise<RecipeCollectionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRecipeCollectionUsers(collectionId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}/users/";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRecipeCollectionUsers(_response);
        });
    }

    protected processAddRecipeCollectionUsers(response: AxiosResponse): Promise<RecipeCollectionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    addRecipeToShoppingList(shoppingListId: string, recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}/recipes/{recipeId}/";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddRecipeToShoppingList(_response);
        });
    }

    protected processAddRecipeToShoppingList(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkShoppingListIngredient(shoppingListId: string, ingredientId: string, isChecked: boolean, body: CheckShoppingListIngredientCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}/{ingredientId}/{isChecked}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        if (ingredientId === undefined || ingredientId === null)
            throw new Error("The parameter 'ingredientId' must be defined.");
        url_ = url_.replace("{ingredientId}", encodeURIComponent("" + ingredientId));
        if (isChecked === undefined || isChecked === null)
            throw new Error("The parameter 'isChecked' must be defined.");
        url_ = url_.replace("{isChecked}", encodeURIComponent("" + isChecked));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckShoppingListIngredient(_response);
        });
    }

    protected processCheckShoppingListIngredient(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkUserHasRecipeAdded(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/recipes/added/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckUserHasRecipeAdded(_response);
        });
    }

    protected processCheckUserHasRecipeAdded(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<boolean>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cloneRecipe(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/clone/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCloneRecipe(_response);
        });
    }

    protected processCloneRecipe(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createMealPlan(body: CreateMealPlanCommand | undefined , cancelToken?: CancelToken | undefined): Promise<MealPlanVm> {
        let url_ = this.baseUrl + "/api/mealplans";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateMealPlan(_response);
        });
    }

    protected processCreateMealPlan(response: AxiosResponse): Promise<MealPlanVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MealPlanVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MealPlanVm>(null as any);
    }

    /**
     * @param startDate Start Date
     * @param endDate End Date
     * @param body (optional) 
     * @return Success
     */
    getWeeklyMealPlans(startDate: string, endDate: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<MealPlanVm[]> {
        let url_ = this.baseUrl + "/api/mealplans?";
        if (startDate === undefined || startDate === null)
            throw new Error("The parameter 'startDate' must be defined and cannot be null.");
        else
            url_ += "startDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === undefined || endDate === null)
            throw new Error("The parameter 'endDate' must be defined and cannot be null.");
        else
            url_ += "endDate=" + encodeURIComponent("" + endDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWeeklyMealPlans(_response);
        });
    }

    protected processGetWeeklyMealPlans(response: AxiosResponse): Promise<MealPlanVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<MealPlanVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MealPlanVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecipe(body: CreateRecipeCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRecipe(_response);
        });
    }

    protected processCreateRecipe(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param name (optional) Search any recipes that contain the name.
     * @param sortBy (optional) alphabetical,recent
     * @param page (optional) page
     * @param tagIds (optional) Comma-separated list of tag IDs to filter recipes.
     * @param showCookedOnly (optional) Filter to show only recipes that have been cooked.
     * @param body (optional) 
     * @return Success
     */
    getRecipes(name: string | undefined, sortBy: string | undefined, page: number | undefined, tagIds: string | undefined, showCookedOnly: boolean | undefined, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm[]> {
        let url_ = this.baseUrl + "/api/recipes?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (tagIds === null)
            throw new Error("The parameter 'tagIds' cannot be null.");
        else if (tagIds !== undefined)
            url_ += "tagIds=" + encodeURIComponent("" + tagIds) + "&";
        if (showCookedOnly === null)
            throw new Error("The parameter 'showCookedOnly' cannot be null.");
        else if (showCookedOnly !== undefined)
            url_ += "showCookedOnly=" + encodeURIComponent("" + showCookedOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipes(_response);
        });
    }

    protected processGetRecipes(response: AxiosResponse): Promise<RecipeVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createRecipeCollection(body: CreateRecipeCollectionCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm> {
        let url_ = this.baseUrl + "/api/collections";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateRecipeCollection(_response);
        });
    }

    protected processCreateRecipeCollection(response: AxiosResponse): Promise<RecipeCollectionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm>(null as any);
    }

    /**
     * @param name (optional) Search any collections that contain the name.
     * @param sortBy (optional) alphabetical,recent
     * @param body (optional) 
     * @return Success
     */
    getCollections(name: string | undefined, sortBy: string | undefined, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm[]> {
        let url_ = this.baseUrl + "/api/collections?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCollections(_response);
        });
    }

    protected processGetCollections(response: AxiosResponse): Promise<RecipeCollectionVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createShoppingList(body: CreateShoppingListCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateShoppingList(_response);
        });
    }

    protected processCreateShoppingList(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param name (optional) Search any recipes that contain the name.
     * @param body (optional) 
     * @return Success
     */
    getShoppingLists(name: string | undefined, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm[]> {
        let url_ = this.baseUrl + "/api/shopping-lists?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetShoppingLists(_response);
        });
    }

    protected processGetShoppingLists(response: AxiosResponse): Promise<ShoppingListVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createTag(body: CreateTagCommand | undefined , cancelToken?: CancelToken | undefined): Promise<TagVm> {
        let url_ = this.baseUrl + "/api/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTag(_response);
        });
    }

    protected processCreateTag(response: AxiosResponse): Promise<TagVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TagVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTags(body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<TagVm[]> {
        let url_ = this.baseUrl + "/api/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTags(_response);
        });
    }

    protected processGetTags(response: AxiosResponse): Promise<TagVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<TagVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createUser(body: CreateNewUserVm | undefined , cancelToken?: CancelToken | undefined): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateUser(_response);
        });
    }

    protected processCreateUser(response: AxiosResponse): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteUser(body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUser(_response);
        });
    }

    protected processDeleteUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getUser(body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: AxiosResponse): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateUser(body: UpdateUserCommand | undefined , cancelToken?: CancelToken | undefined): Promise<UserVm> {
        let url_ = this.baseUrl + "/api/users";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateUser(_response);
        });
    }

    protected processUpdateUser(response: AxiosResponse): Promise<UserVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<UserVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteMealPlan(mealPlanId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/mealplans/{mealPlanId}";
        if (mealPlanId === undefined || mealPlanId === null)
            throw new Error("The parameter 'mealPlanId' must be defined.");
        url_ = url_.replace("{mealPlanId}", encodeURIComponent("" + mealPlanId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteMealPlan(_response);
        });
    }

    protected processDeleteMealPlan(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRecipe(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRecipe(_response);
        });
    }

    protected processDeleteRecipe(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSingleRecipe(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSingleRecipe(_response);
        });
    }

    protected processGetSingleRecipe(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRecipe(recipeId: string, body: UpdateRecipeCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRecipe(_response);
        });
    }

    protected processUpdateRecipe(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteRecipeCollection(collectionId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/collections/{collectionId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteRecipeCollection(_response);
        });
    }

    protected processDeleteRecipeCollection(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteShoppingList(shoppingListId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteShoppingList(_response);
        });
    }

    protected processDeleteShoppingList(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateShoppingList(shoppingListId: string, body: UpdateShoppingListCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateShoppingList(_response);
        });
    }

    protected processUpdateShoppingList(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteTag(tagId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/tags/{tagId}";
        if (tagId === undefined || tagId === null)
            throw new Error("The parameter 'tagId' must be defined.");
        url_ = url_.replace("{tagId}", encodeURIComponent("" + tagId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTag(_response);
        });
    }

    protected processDeleteTag(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param url Link to an instagram reel or post
     * @param body (optional) 
     * @return Success
     */
    generateRecipeFromInstagramUrl(url: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/generate?";
        if (url === undefined || url === null)
            throw new Error("The parameter 'url' must be defined and cannot be null.");
        else
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateRecipeFromInstagramUrl(_response);
        });
    }

    protected processGenerateRecipeFromInstagramUrl(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateRecipeFromText(body: string | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/generateRecipeFromText";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateRecipeFromText(_response);
        });
    }

    protected processGenerateRecipeFromText(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateShoppingListForMealPlan(body: CreateShoppingListFromWeeklyMealPlanCommand | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/mealplans/shopping-list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGenerateShoppingListForMealPlan(_response);
        });
    }

    protected processGenerateShoppingListForMealPlan(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param name (optional) Search any recipes that contain the name.
     * @param sortBy (optional) alphabetical,recent
     * @param page (optional) page
     * @param body (optional) 
     * @return Success
     */
    getRecipesAdmin(name: string | undefined, sortBy: string | undefined, page: number | undefined, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm[]> {
        let url_ = this.baseUrl + "/api/recipes/admin?";
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipesAdmin(_response);
        });
    }

    protected processGetRecipesAdmin(response: AxiosResponse): Promise<RecipeVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAppVersion(body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<AppVersionVm> {
        let url_ = this.baseUrl + "/api/appversion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppVersion(_response);
        });
    }

    protected processGetAppVersion(response: AxiosResponse): Promise<AppVersionVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<AppVersionVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppVersionVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCollectionsWithoutRecipe(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionVm[]> {
        let url_ = this.baseUrl + "/api/collections/recipe/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCollectionsWithoutRecipe(_response);
        });
    }

    protected processGetCollectionsWithoutRecipe(response: AxiosResponse): Promise<RecipeCollectionVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionVm[]>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getCommonItems(body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<CommonItemVm[]> {
        let url_ = this.baseUrl + "/api/common-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommonItems(_response);
        });
    }

    protected processGetCommonItems(response: AxiosResponse): Promise<CommonItemVm[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<CommonItemVm[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommonItemVm[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateCommonItems(body: CommonItemDto[] | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/common-items";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCommonItems(_response);
        });
    }

    protected processUpdateCommonItems(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param name (optional) Search any recipes within the collection that contain the name.
     * @param sortBy (optional) alphabetical,recent
     * @param body (optional) 
     * @return Success
     */
    getSinglePublicCollection(collectionId: string, name: string | undefined, sortBy: string | undefined, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeCollectionWithRecipesVm> {
        let url_ = this.baseUrl + "/api/collections/public/{collectionId}?";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        if (name === null)
            throw new Error("The parameter 'name' cannot be null.");
        else if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "sortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSinglePublicCollection(_response);
        });
    }

    protected processGetSinglePublicCollection(response: AxiosResponse): Promise<RecipeCollectionWithRecipesVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeCollectionWithRecipesVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeCollectionWithRecipesVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSinglePublicRecipe(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/public/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSinglePublicRecipe(_response);
        });
    }

    protected processGetSinglePublicRecipe(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getRecipeSuggestedLastCookedDate(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}/suggestedLastCookedDate";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRecipeSuggestedLastCookedDate(_response);
        });
    }

    protected processGetRecipeSuggestedLastCookedDate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<string>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getSinglePublicShoppingList(shoppingListId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/public/{shoppingListId}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSinglePublicShoppingList(_response);
        });
    }

    protected processGetSinglePublicShoppingList(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @return Success
     */
    getHealthz(  cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Healthz";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHealthz(_response);
        });
    }

    protected processGetHealthz(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markRecipeAsCooked(recipeId: string, body: MarkRecipeAsCookedCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}/markAsCooked";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkRecipeAsCooked(_response);
        });
    }

    protected processMarkRecipeAsCooked(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markShoppingListActive(shoppingListId: string, active: boolean, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}/active/{active}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        if (active === undefined || active === null)
            throw new Error("The parameter 'active' must be defined.");
        url_ = url_.replace("{active}", encodeURIComponent("" + active));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkShoppingListActive(_response);
        });
    }

    protected processMarkShoppingListActive(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    markShoppingListCompleted(shoppingListId: string, completed: boolean, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<ShoppingListVm> {
        let url_ = this.baseUrl + "/api/shopping-lists/{shoppingListId}/completed/{completed}";
        if (shoppingListId === undefined || shoppingListId === null)
            throw new Error("The parameter 'shoppingListId' must be defined.");
        url_ = url_.replace("{shoppingListId}", encodeURIComponent("" + shoppingListId));
        if (completed === undefined || completed === null)
            throw new Error("The parameter 'completed' must be defined.");
        url_ = url_.replace("{completed}", encodeURIComponent("" + completed));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkShoppingListCompleted(_response);
        });
    }

    protected processMarkShoppingListCompleted(response: AxiosResponse): Promise<ShoppingListVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<ShoppingListVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoppingListVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleRecipeFavourite(recipeId: string, body: CancellationToken | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/{recipeId}/favourite";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleRecipeFavourite(_response);
        });
    }

    protected processToggleRecipeFavourite(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateIngredient(ingredientId: string, body: UpdateIngredientCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/ingredients/{ingredientId}";
        if (ingredientId === undefined || ingredientId === null)
            throw new Error("The parameter 'ingredientId' must be defined.");
        url_ = url_.replace("{ingredientId}", encodeURIComponent("" + ingredientId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateIngredient(_response);
        });
    }

    protected processUpdateIngredient(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateRecipeTags(body: UpdateRecipeTagsCommand | undefined , cancelToken?: CancelToken | undefined): Promise<RecipeVm> {
        let url_ = this.baseUrl + "/api/recipes/tags";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateRecipeTags(_response);
        });
    }

    protected processUpdateRecipeTags(response: AxiosResponse): Promise<RecipeVm> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JSON.parse(resultData200);
            return Promise.resolve<RecipeVm>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            return throwException("Bad Request", status, _responseText, _headers);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RecipeVm>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    uploadImage(recipeId: string, body: Blob | undefined , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/recipes/images/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = body;

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "multipart/form-data",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadImage(_response);
        });
    }

    protected processUploadImage(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IntPtr {
}

export interface SafeWaitHandle {
    readonly isClosed?: boolean;
    readonly isInvalid?: boolean;
}

export interface WaitHandle {
    handle?: IntPtr;
    safeWaitHandle?: SafeWaitHandle;
}

export interface CancellationToken {
    readonly isCancellationRequested?: boolean;
    readonly canBeCanceled?: boolean;
    waitHandle?: WaitHandle;
}

export interface IngredientVm {
    id: string;
    name: string;
    measurement?: string | undefined;
    isOptional?: boolean | undefined;
    quantity?: number | undefined;
    category?: string | undefined;
    quantityIsFraction?: boolean | undefined;
    quantityNumerator?: number | undefined;
    quantityDenominator?: string | undefined;
    quantityFractionAsDecimal?: number | undefined;
    quantityFractionCombined?: string | undefined;
    isShoppingListChecked?: boolean | undefined;
    dateCreated?: string;
    dateUpdated?: string | undefined;
    displayOrder?: number;
}

export interface InstructionVm {
    id: string;
    name: string;
    isOptional?: boolean | undefined;
    dateCreated?: string;
    dateUpdated?: string | undefined;
    displayOrder?: number;
}

export interface CookingTimeVm {
    id?: string;
    hours?: number | undefined;
    minutes?: number | undefined;
}

export interface NutritionInformationVm {
    id?: string;
    calories?: number | undefined;
    protein?: number | undefined;
    carbohydrates?: number | undefined;
    fats?: number | undefined;
}

export interface ImageVariantVm {
    fileName?: string | undefined;
    size?: string | undefined;
    readonly url?: string | undefined;
    readonly cdnUrl?: string | undefined;
}

export interface RecipeImageVm {
    dateCreated?: string;
    imageId?: string;
    originalFileName?: string | undefined;
    uniqueImageFileName?: string | undefined;
    recipeId?: string;
    url?: string | undefined;
    cdnUrl?: string | undefined;
    imageVariants?: ImageVariantVm[] | undefined;
    displayOrder?: number;
}

export interface TagVm {
    id: string;
    name: string;
    isDefault: boolean;
}

export interface RecipeVm {
    id: string;
    recipeId?: string;
    isFavourite?: boolean;
    name: string;
    createdByUserId?: string;
    clonedFromRecipeId?: string | undefined;
    ingredients?: IngredientVm[] | undefined;
    instructions?: InstructionVm[] | undefined;
    description?: string | undefined;
    link?: string | undefined;
    prepTime?: CookingTimeVm;
    cookTime?: CookingTimeVm;
    difficulty?: number | undefined;
    servings?: number | undefined;
    nutritionInformation?: NutritionInformationVm;
    recipeImages?: RecipeImageVm[] | undefined;
    dateCreated?: string;
    isGloballyVisible?: boolean;
    recipeNote?: string | undefined;
    tags?: TagVm[] | undefined;
    lastCookedDate?: string | undefined;
}

export enum AccessLevel {
    Read = 0,
    Edit = 1,
    Owner = 2,
}

export interface RecipeCollectionVm {
    id: string;
    createdByUserId?: string;
    recipes?: RecipeVm[] | undefined;
    isPublic?: boolean;
    name?: string | undefined;
    description?: string | undefined;
    recipeCount?: number;
    thumbnailRecipe?: RecipeVm;
    thumbnailRecipeId?: string | undefined;
    currentUserAccessLevel?: AccessLevel;
    dateCreated?: string;
}

export interface ShoppingListVm {
    id: string;
    name: string;
    description?: string | undefined;
    createdByUserId?: string;
    recipes?: RecipeVm[] | undefined;
    ingredients?: IngredientVm[] | undefined;
    dateCreated: string;
    completedDate?: string | undefined;
    isCompleted?: boolean;
    isActive?: boolean;
}

export interface CheckShoppingListIngredientCommand {
    shoppingListId: string;
    ingredientId: string;
    duplicateIngredients?: string[] | undefined;
    checked?: boolean;
}

export enum MealPlanSlot {
    Breakfast = 1,
    Snack = 2,
    Lunch = 3,
    Dinner = 4,
    Dessert = 5,
    Other = 6,
}

export interface CreateMealPlanCommand {
    recipeId?: string;
    mealDate?: string;
    mealSlot?: MealPlanSlot;
}

export interface MealPlanVm {
    id: string;
    recipe?: RecipeVm;
    userId?: string;
    mealDate: string;
    mealSlot: MealPlanSlot;
}

export interface CreateIngredientCommand {
    name?: string | undefined;
    quantity?: number | undefined;
    measurement?: string | undefined;
    isOptional?: boolean | undefined;
    quantityIsFraction?: boolean | undefined;
    quantityNumerator?: number | undefined;
    quantityDenominator?: string | undefined;
    displayOrder?: number;
}

export interface CreateInstructionCommand {
    name?: string | undefined;
    isOptional?: boolean | undefined;
    displayOrder?: number;
}

export interface CreateRecipeCommand {
    name: string;
    ingredients?: CreateIngredientCommand[] | undefined;
    instructions?: CreateInstructionCommand[] | undefined;
    description?: string | undefined;
    link?: string | undefined;
    prepTime?: CookingTimeVm;
    cookTime?: CookingTimeVm;
    difficulty?: number | undefined;
    servings?: number | undefined;
    nutritionInformation?: NutritionInformationVm;
    recipeImage?: string | undefined;
    recipeNote?: string | undefined;
}

export interface CreateRecipeCollectionCommand {
    name: string;
    description?: string | undefined;
}

export interface CreateShoppingListCommand {
    name: string;
    description?: string | undefined;
    ingredients?: CreateIngredientCommand[] | undefined;
}

export interface CreateTagCommand {
    name: string;
}

export enum FirebaseAuthProvider {
    Google = 0,
    Apple = 1,
    Email = 2,
}

export interface CreateNewUserVm {
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    externalAuthProviderSub: string;
    firebaseProvider: FirebaseAuthProvider;
}

export interface RecipeCollectionUserVm {
    id?: string;
    recipeCollectionId?: string;
    dateAdded?: string;
}

export interface UserVm {
    id: string;
    email: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    displayName?: string | undefined;
    recipeCollectionIds?: RecipeCollectionUserVm[] | undefined;
    isBetaTester?: boolean | undefined;
    hasAutoGeneratedNewUserData?: boolean;
    isPaidUser?: boolean;
    isAdminUser?: boolean;
    includeGlobalRecipes?: boolean;
}

export interface UpdateUserCommand {
    includeGlobalRecipes: boolean;
}

export interface UpdateRecipeCommand {
    id: string;
    name?: string | undefined;
    ingredients?: IngredientVm[] | undefined;
    instructions?: InstructionVm[] | undefined;
    description?: string | undefined;
    link?: string | undefined;
    prepTime?: CookingTimeVm;
    cookTime?: CookingTimeVm;
    difficulty?: number | undefined;
    servings?: number | undefined;
    nutritionInformation?: NutritionInformationVm;
    recipeImage?: string | undefined;
    recipeNote?: string | undefined;
}

export interface UpdateShoppingListCommand {
    id: string;
    name?: string | undefined;
    description?: string | undefined;
    recipes?: RecipeVm[] | undefined;
    ingredients?: IngredientVm[] | undefined;
}

export interface CreateShoppingListFromWeeklyMealPlanCommand {
    startDate?: string;
    endDate?: string;
    existingShoppingListId?: string | undefined;
}

export interface AppVersionVm {
    appVersion?: string | undefined;
}

export interface CommonItemVm {
    id?: string;
    name?: string | undefined;
    measurement?: string | undefined;
    quantity?: number | undefined;
    usageCount?: number;
    lastUsedDate?: string | undefined;
}

export interface CommonItemDto {
    id?: string | undefined;
    name: string;
    measurement?: string | undefined;
    quantity?: number | undefined;
    isSelected?: boolean | undefined;
}

export interface RecipeCollectionWithRecipesVm {
    id?: string;
    createdByUserId?: string;
    recipes?: RecipeVm[] | undefined;
    isPublic?: boolean;
    name?: string | undefined;
    description?: string | undefined;
}

export interface MarkRecipeAsCookedCommand {
    id: string;
    lastCookedDate?: string;
}

export interface UpdateIngredientCommand {
    id: string;
    category?: string | undefined;
}

export interface UpdateRecipeTagsCommand {
    recipeId: string;
    selectedTagIds: string[];
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}